import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InstallationDetailsStore, InstallationsStore } from '@store';

import { InstallationService } from '../../../services/installation.service';
import { UIService } from '@services';

@Component({
  selector: 'app-deregister-confirmation-modal',
  templateUrl: './deregister-confirmation-modal.component.html',
  styleUrls: ['./deregister-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeregisterConfirmationModalComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      installationId: number;
      gatewaySerial: string;
    },
    public dialogRef: MatDialogRef<DeregisterConfirmationModalComponent>,
    public installationsStore: InstallationsStore,
    public installationDetailsStore: InstallationDetailsStore,
    private installationService: InstallationService,
    private router: Router,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.installationsStore.deregisterInstallationState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state) => {
        if (!state.pending && state.success) {
          this.dialogRef.close();
          this.installationService.showDeregisterInstallationSuccess();
          this.installationsStore.listInstallations();
          this.router.navigateByUrl('/installations');
        } else if (!state.pending && state.error) {
          this.installationService.showDeregisterInstallationError();
        }
      });

    this.installationDetailsStore.deregisterGatewayState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state) => {
        if (!state.pending && state.success) {
          this.dialogRef.close();
          this.uiService.closeActiveOverlay();
          this.installationService.showDeregisterGatewaySuccess();
          this.router.navigateByUrl(`/installations/${this.data.installationId}`);
        } else if (!state.pending && state.error) {
          this.installationService.showDeregisterGatewayError();
        }
      });
  }

  onConfirm(): void {
    if (this.data.gatewaySerial) {
      this.installationDetailsStore.deregisterGateway(
        this.data.installationId,
        this.data.gatewaySerial
      );
    } else {
      this.installationsStore.deregisterInstallation(this.data.installationId);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.installationDetailsStore.resetDeregisterState();
  }
}
